import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'modules/store';

const selectState = (x: RootState) => x.permissionsReducer;

export const selectPermissions = createSelector(selectState, ({ permissions }) => permissions);
